import Weibo from './weibo/index';
import Fb from './fb/index';
import Home from './home';

export const routes = {
  create_weibo: {
    path: '/live/weibo/create',
    component: Weibo.Create,
    exactly: true,
  },
  live_weibo: {
    path: '/live/weibo',
    component: Weibo.Streams,
    exactly: true,
  },
  create_fb: {
    path: '/live/facebook/create',
    component: Fb.Create,
    exactly: true,
  },
  live_fb: {
    path: '/live/facebook',
    component: Fb.Streams,
    exactly: true,
  },
  live_home: {
    path: '/live/',
    component: Home,
    exactly: true,
  },
};



// WEBPACK FOOTER //
// ./src/views/live/index.js